import React from 'react';
import { Megaphone } from 'lucide-react';

export function TradeshowBanner({ month, tradeShowMonth, treasury, onAttend }) {
  return (
    <div className="surface-card p-3 flex items-center justify-between gap-3" data-testid="tradeshow-banner">
      <div className="flex items-center gap-2">
        <Megaphone className="w-4 h-4 text-warn" />
        <div>
          <p className="text-sm font-semibold text-slate-100">Salon régional du transport</p>
          <p className="text-[10px] text-slate-400">Coût 1 000 € · +5 notoriété · 1 fois par mois</p>
        </div>
      </div>
      <button
        onClick={onAttend}
        disabled={tradeShowMonth === month || treasury < 1000}
        className="text-xs px-3 py-2 rounded-md bg-warn text-ink-900 font-mono font-bold uppercase tracking-wider disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid="attend-tradeshow-btn"
        title={tradeShowMonth === month ? 'Déjà participé ce mois-ci' : treasury < 1000 ? 'Trésorerie insuffisante' : 'Participer au salon'}
      >
        {tradeShowMonth === month ? 'Participé ✓' : 'Participer'}
      </button>
    </div>
  );
}
